module.exports = __webpack_public_path__ + "static/media/Elvira_figure.bdb7ee42.jpeg";